<template>
  <Loading v-if="!fullyLoaded" />
  <SubscriptionForm
    v-else
    :resource="resource"
    :submit="submit"
    :destroy="destroy"
    :cancel="cancel"
  />
</template>

<script>
import EditView from '@/mixins/editView';
import ResourceService from '@/services/resources/subscriptions_service';
import SiteService from '@/services/resources/sites_service';

export default {
  mixins: [EditView],
  components: {
    SubscriptionForm: () => import('@/components/forms/SubscriptionForm.vue'),
  },
  data() {
    return {
      urlFragment: 'email-reports',
      resourceService: ResourceService,
    };
  },
  asyncComputed: {
    resource: {
      get() {
        return this.resourceService
          .get(this.$route.params.resource_id, this.resourceParams)
          .then((resource) => {
            return resource.data;
          });
      },
      default: { sendInterval: {} },
    },
    sites: {
      get() {
        if (this.siteId) {
          return SiteService.get(this.siteId).then((site) => {
            return [site.data];
          });
        }

        return SiteService.index().then((sites) => {
          return sites.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
  },
};
</script>
